import React from 'react';
import { useTheme } from 'styled-components';
import { Button } from 'src/components/atoms';
import { StyledIconInButton } from 'src/components/foundations/foundations.styles';
import { SpinnerButton } from '../SpinnerButton';
import {
  Container,
  Description,
  EmptyStateSize,
  ImageContainer,
  IntercomLink,
  Title,
} from './EmptyState.styles';
interface Props {
  size?: EmptyStateSize;
  title: string;
  description: React.ReactNode | string;
  buttonText?: string;
  onButtonClick?: () => void;
  renderIconButton?: boolean;
  loading?: boolean;
  notificationEmptyState?: boolean;
  'data-testid'?: string;
  intercomLink?: {
    link: string;
    title: string;
    name: string;
  };
}

export const EmptyState = ({
  size = 'default',
  loading = false,
  title,
  description,
  buttonText,
  onButtonClick,
  notificationEmptyState,
  ...props
}: Props) => {
  const theme = useTheme();
  const imageSrc = notificationEmptyState
    ? theme.isVaultVariant
      ? '/assets/empty-notification-state.svg'
      : '/assets/empty-notification-state-atlas.svg'
    : theme.isVaultVariant
      ? '/assets/empty-state.svg'
      : '/assets/empty-state-atlas.svg';

  return (
    <Container size={size} data-testid={props['data-testid']}>
      <ImageContainer $size={size === 'small' ? '240px' : '380px'}>
        <img src={imageSrc} alt="Empty state" width="100%" />
      </ImageContainer>
      <Title>{title}</Title>
      <Description>
        {description}
        {props.intercomLink && (
          <IntercomLink
            href={props.intercomLink.link}
            size="medium"
            target="_blank"
            rel="no-referrer"
            data-testid={`${props.intercomLink.name}-intercom-link`}
          >
            &apos;{props.intercomLink.title}&apos;
          </IntercomLink>
        )}
      </Description>
      {!onButtonClick ||
        (!notificationEmptyState &&
          (props.renderIconButton ? (
            <Button variant="primary" size="small" onClick={onButtonClick}>
              <StyledIconInButton
                size="small"
                position="left"
                className="uil uil-plus"
              />
              {buttonText}
            </Button>
          ) : (
            <SpinnerButton
              onClick={onButtonClick}
              loading={loading}
              data-testid={`${props['data-testid']}-button`}
            >
              {buttonText}
            </SpinnerButton>
          )))}
    </Container>
  );
};
